// @flow
import moment from 'moment';

import * as routeBuilder from 'Routes/routeBuilder';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { getDefaultProposal } from 'Utils/proposal/proposalUtils';
import { CRITERIA_OFFSETSELL } from 'Utils/request/requestDictionary';

export const PAGE_BE_ACCOMMODATION = 'accommodation';
export const PAGE_BE_TRANSPORT = 'transport';
export const PAGE_BE_SERVICES = 'services';
export const PAGE_BE_ACTIVITIES = 'activities';
export const PAGE_BE_SERVICES_ALL_INCLUSIVE = 'allInclusive';
export const PAGE_BE_PARTICIPANTS = 'participants';
export const PAGE_BE_BANKING = 'banking';

export function getBookingEngineUri(
  page: string = PAGE_BE_ACCOMMODATION,
  proposals: Array<Proposal>,
  resort?: Resort,
  selectedProposalId?: string,
  otherQueryParameters?: {},
): string {
  const proposalIds = proposals.map(proposal => proposal.id);
  const defaultProposal = getDefaultProposal(proposals, resort);
  const queryParams = {
    ...otherQueryParameters,
    proposalIds,
    selectedProposalId: selectedProposalId || defaultProposal.id,
  };

  return routeBuilder.buildUrl('booking', { page }, queryParams);
}

type GQLProps = {
  bookingCriteria: {
    offsetSell: string,
  },
};

export const getBookingCriteriaOffsetSell = async (
  productId: string,
  appContext: AppContext,
): Promise<GQLProps> => {
  const getQuery = () => {
    return `query {
                  bookingCriteria(productId: "${productId}") {
                    offsetSell
                  }
            }`;
  };
  const query = getQuery();
  return graphQLClient.runQuery(query, appContext, { requestName: CRITERIA_OFFSETSELL });
};

// check if the departureDate comes after today plus the offsetSell (in days), which is defined by the API
export const checkIsDepartureDateAvailaible = (
  departureDate: string,
  offsetSell: string,
): boolean => {
  return moment(departureDate).isBefore(moment().add(offsetSell, 'd'), 'day');
};
